import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg"
}

/**
 * Default inline loading spinner; size variants for buttons, cells and page-level waits.
 *
 * @category Feedback
 */
function Spinner({ className, size = "default", ...props }: SpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-6 w-6",
    lg: "h-8 w-8",
  }

  return (
    <div
      role="status"
      className={cn("flex items-center justify-center", className)}
      {...props}
    >
      <Loader2
        className={cn("animate-spin text-primary", sizeClasses[size])}
      />
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export { Spinner }
export type { SpinnerProps }
